import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PLinkModule } from '@panaya/ui/p-link';
import { PMultipleProgressBarComponent } from './p-multiple-progress-bar.component';

@NgModule({
    declarations: [PMultipleProgressBarComponent],
    imports: [CommonModule, MatTooltipModule, PLinkModule],
    exports: [PMultipleProgressBarComponent]
})
export class PMultipleProgressBarModule {}
